import React from 'react';
import {
  PRICE_LIST_PROMOTION_STATES,
  formatPromotionDate,
  formatPromotionTerms,
  getPromotionState,
  isPromotionCurrent,
  normalizeFormatPromotions,
} from '../../utils/priceListPromotions';

const stateStyles = {
  [PRICE_LIST_PROMOTION_STATES.ACTIVE]: 'border-emerald-200 bg-emerald-100 text-emerald-800',
  [PRICE_LIST_PROMOTION_STATES.SCHEDULED]: 'border-blue-200 bg-blue-100 text-blue-800',
};

const stateLabels = {
  [PRICE_LIST_PROMOTION_STATES.ACTIVE]: 'Activa',
  [PRICE_LIST_PROMOTION_STATES.SCHEDULED]: 'Programada',
};

const QuickPromotionRows = ({
  format,
  formatLabel,
  now = Date.now(),
  canUpdate = false,
  saving = false,
  disabled = false,
  error = '',
  onEdit,
  onEnd,
}) => {
  const promotions = normalizeFormatPromotions(format)
    .filter((promotion) => isPromotionCurrent(promotion, now));

  if (!promotions.length && !error) return null;

  return (
    <>
      {promotions.map((promotion) => {
        const state = getPromotionState(promotion, now);
        const active = state === PRICE_LIST_PROMOTION_STATES.ACTIVE;
        return (
          <tr
            key={promotion.id}
            data-testid={`quick-promotion-${promotion.id}`}
            className="border-t border-amber-100 bg-amber-50/70"
          >
            <td colSpan={5} className="py-2 pl-10 pr-3">
              <div className="flex flex-col gap-2 rounded-lg border border-amber-200 bg-white px-3 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-bold ${stateStyles[state] || stateStyles[PRICE_LIST_PROMOTION_STATES.SCHEDULED]}`}>
                      {stateLabels[state] || 'Programada'}
                    </span>
                    <strong className="text-sm text-amber-950">{formatPromotionTerms(promotion)}</strong>
                  </div>
                  <p className="mt-1 text-xs text-slate-600">
                    {active ? 'Vigente desde el' : 'Comienza el'} {formatPromotionDate(promotion.startDate)} · termina al finalizar el {formatPromotionDate(promotion.endDate)} (hora de Chile)
                  </p>
                </div>
                {canUpdate && (
                  <div className="flex shrink-0 flex-wrap gap-2">
                    <button
                      type="button"
                      disabled={disabled || saving}
                      onClick={() => onEdit?.(promotion)}
                      aria-label={`Editar precio temporal de ${formatLabel}`}
                      className="min-h-8 rounded-md border border-amber-300 bg-white px-2.5 py-1 text-xs font-bold text-amber-800 hover:bg-amber-50 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      disabled={disabled || saving}
                      onClick={() => onEnd?.(promotion)}
                      aria-label={`${active ? 'Finalizar' : 'Cancelar'} precio temporal de ${formatLabel}`}
                      className="min-h-8 rounded-md border border-red-200 bg-white px-2.5 py-1 text-xs font-bold text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      {saving ? 'Guardando…' : active ? 'Finalizar' : 'Cancelar'}
                    </button>
                  </div>
                )}
              </div>
            </td>
          </tr>
        );
      })}
      {error && (
        <tr className="border-t border-red-100 bg-red-50">
          <td colSpan={5} className="px-3 py-2">
            <p role="alert" className="text-xs font-semibold text-red-700">{error}</p>
          </td>
        </tr>
      )}
    </>
  );
};

export default QuickPromotionRows;
